import React, { useState } from 'react';
import Image from 'next/image';
import styles from './developerschoose.module.scss';
import { Fade } from 'react-awesome-reveal';
import { Typography } from '../Typography';

const DevelopersChoose = () => {
  const [selectedBenefit, setSelectedBenefit] = useState(0);

  // Benefits data based on Figma design
  const benefits = [
    {
      title: 'Faster Development',
      description:
        'VxFX streamlines the plugin creation process, reducing development time by up to 80% through a unified, cross-platform codebase.',
    },
    {
      title: 'Simplified Maintenance',
      description:
        'Manage, update, and optimize all plugin versions from a single source without rewriting code for different hosts or GPU architectures.',
    },
    {
      title: 'Future-Proof Innovation',
      description:
        'Stay ahead of evolving hardware and software with a framework designed for long-term compatibility, giving you more freedom to focus on creativity and performance.',
    },
  ];

  return (
    <div className={styles.benefitsContainer}>
      <div className={styles.benefitsContent}>
        {/* Header Section */}
        <div className={styles.benefitsHeader}>
          <Fade triggerOnce duration={1000}>
            <Typography variant="text-md" color="grayDark-300" className={styles.benefitsSubtitle}>
              Benefits
            </Typography>
          </Fade>

          <Fade triggerOnce duration={1000}>
            <Typography
              variant="display-lg"
              as="h2"
              color="grayDark-50"
              weight="semibold"
              className={styles.benefitsTitle}
            >
              Why Developers Choose VxFX
            </Typography>
          </Fade>

          <Fade triggerOnce duration={1000}>
            <Typography
              variant="text-lg"
              color="grayDark-400"
              className={styles.benefitsDescription}
            >
              Simplify development, boost efficiency, and ensure lasting compatibility across
              platforms.
            </Typography>
          </Fade>
        </div>

        {/* Main Content */}
        <div className={styles.benefitsMain}>
          {/* Left Side - Description and Benefits */}
          <div className={styles.benefitsLeft}>
            <div className={styles.benefitsList}>
              {benefits.map((benefit, index) => (
                <Fade key={index} triggerOnce duration={1000} delay={index * 200}>
                  <div
                    className={`${styles.benefitItem} ${
                      selectedBenefit === index ? styles.selected : ''
                    }`}
                    onClick={() => setSelectedBenefit(index)}
                  >
                    <div className={styles.benefitContent}>
                      <Typography
                        variant="text-lg"
                        as="h3"
                        color="grayDark-50"
                        weight="semibold"
                        className={styles.benefitTitle}
                      >
                        {benefit.title}
                      </Typography>
                      <Typography
                        variant="text-md"
                        color="grayDark-400"
                        className={styles.benefitDescription}
                      >
                        {benefit.description}
                      </Typography>
                    </div>
                  </div>
                </Fade>
              ))}
            </div>
          </div>

          {/* Right Side - Futuristic Graphic */}
          <div className={styles.benefitsRight}>
            <div className={styles.benefitsGraphic}>
              {/* benefitsGraphic is display:flex, so next/image's responsive
                  wrapper (which relies on a block-level parent to inherit
                  100% width) needs an explicit-width div here or it collapses
                  to 0 in the flex layout. */}
              <div style={{ width: '100%' }}>
                <Image
                  src="/product-benefit.jpg"
                  alt="Why Developers Choose VxFX - Faster Development, Simplified Maintenance, and Future-Proof Innovation"
                  className={styles.graphicImage}
                  width={1024}
                  height={1024}
                  layout="responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevelopersChoose;
